import { render } from "./TheFooter.vue?vue&type=template&id=95cc2828&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=95cc2828&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/theearcasino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95cc2828"]])

export default __exports__